import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { SEO } from "../components/SEO";
import { NotFound } from "../components/site/NotFound";

export function BlogListPage() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.posts || [])).catch(() => {}); }, []);
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-12 md:py-16" data-testid="blog-page">
      <SEO title="Journal" path="/blog" description="Reading guides, magazine roundups and publishing stories from the BookMala editors." />
      <span className="eyebrow">The BookMala Journal</span>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-3 text-bm-ink">Reading guides & roundups</h1>
      <div className="mt-14 space-y-10">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="group block bm-card p-8 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-card-hover" data-testid={`blog-card-${p.slug}`}>
            <h2 className="font-display text-2xl md:text-3xl font-semibold text-bm-ink group-hover:text-bm-terra transition-colors duration-200">{p.title}</h2>
            <p className="text-bm-body mt-3 leading-relaxed max-w-2xl">{p.excerpt}</p>
            <span className="inline-block mt-4 text-sm font-semibold text-bm-terra">Read the story →</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setPost(null); setNotFound(false);
    api.get(`/blog/${slug}`).then((r) => setPost(r.post)).catch(() => setNotFound(true));
  }, [slug]);
  if (notFound) return <NotFound title="Story not found" message="This journal entry doesn't exist or was unpublished." testId="post-not-found" />;
  if (!post) return <div className="max-w-3xl mx-auto px-4 py-24 animate-pulse" data-testid="post-loading"><div className="h-12 bg-bm-sand/60 rounded w-2/3 mb-6" /><div className="h-64 bg-bm-sand/60 rounded" /></div>;
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-8 py-16 md:py-24" data-testid="blog-post-page">
      <SEO title={post.title} description={post.excerpt} path={`/blog/${slug}`} type="article" />
      <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-bm-muted hover:text-bm-terra transition-colors duration-200" data-testid="blog-back-link">
        <ArrowLeft className="w-4 h-4" /> All stories
      </Link>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-6 text-bm-ink">{post.title}</h1>
      <p className="eyebrow mt-5">By the BookMala Editors</p>
      <div className="mt-10 space-y-6 text-bm-body leading-relaxed text-lg whitespace-pre-line">{post.content}</div>
    </article>
  );
}
